<template>
  <v-btn
    fab
    large
    fixed
    bottom
    left
    color="red darken-2"
    class="floating-fuelman-btn"
    :loading="loading"
    @click="handleFuelmanClick"
    elevation="8"
  >
    <v-icon color="white">mdi-gas-station</v-icon>
  </v-btn>
</template>

<script>
import google from '@/apis/google';

export default {
  name: 'FloatingFuelmanButton',
  data() {
    return {
      loading: false,
      gettingLocation: false,
      errorStr: '',
      location: null,
    };
  },
  methods: {
    async handleFuelmanClick() {
      this.loading = true;
      
      try {
        if (!('geolocation' in navigator)) {
          this.$swal.fire({
            title: 'Error',
            text: 'La geolocalización no está disponible en este navegador.',
            icon: 'error'
          });
          this.loading = false;
          return;
        }

        const position = await this.getCurrentPosition();
        const postalCode = await this.getPostalCodeFromCoordinates(
          position.coords.latitude, 
          position.coords.longitude
        );
        
        if (postalCode) {
          const fuelmanUrl = `https://sitelocator.fuelman.com/sites/fuelman/?zipcode=${postalCode}`;
          window.open(fuelmanUrl, '_blank');
        } else {
          this.$swal.fire({
            title: 'Error',
            text: 'No se pudo obtener el código postal de tu ubicación.',
            icon: 'error'
          });
        }
        
      } catch (error) {
        let errorMessage = 'No se pudo obtener tu ubicación.';
        
        if (error.code === 1) {
          errorMessage = 'Necesitas permitir el acceso a tu ubicación para usar esta función.';
        } else if (error.code === 2) {
          errorMessage = 'No se pudo determinar tu ubicación. Intenta de nuevo.';
        } else if (error.code === 3) {
          errorMessage = 'El tiempo de espera para obtener la ubicación se agotó.';
        }
        
        this.$swal.fire({
          title: 'Error de Ubicación',
          text: errorMessage,
          icon: 'error'
        });
      }
      
      this.loading = false;
    },
    
    getCurrentPosition() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: true,
            timeout: 15000,
            maximumAge: 300000
          }
        );
      });
    },
    
    async getPostalCodeFromCoordinates(lat, lng) {
      try {
        const response = await google.geocode(`${lat},${lng}`);
        const results = response.data.results;
        
        if (results && results.length > 0) {
          for (const result of results) {
            for (const component of result.address_components) {
              if (component.types.includes('postal_code')) {
                return component.long_name;
              }
            }
          }
        }
        
        return null;
      } catch (error) {
        console.error('Error getting postal code:', error);
        return null;
      }
    }
  }
};
</script>

<style scoped>
.floating-fuelman-btn {
  margin-bottom: 0;
  margin-right: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  z-index: 1000;
}

.floating-fuelman-btn:hover {
  transform: scale(1.1);
  transition: transform 0.2s ease-in-out;
}
</style>